import { browserHistory } from '@/routing/browserHistory';
import { getParameterizedLink } from '@/utils/getLinkWithSubscriptionId.utils';

function useVarBillingNavigation() {
  const goToVarBillingBySearch = (searchText?: string) => {
    const link = searchText
      ? `/variable-billing?search=${encodeURIComponent(searchText)}`
      : '/variable-billing';
    browserHistory.push(getParameterizedLink(link));
  };

  return { goToVarBillingBySearch };  
}

export default useVarBillingNavigation;
